const state = {
  groupSelected: false,
  //是否选中组
  controlDatas: [],
  //控件集合--formDataArray
  itemid: '',
  activeIdx: -1,
  //一级控件选中的index
  groupItemActiveIdx: -1,
  //控件组里选中的index
  pageModuleShow: 2,
  //前端动态页面产品列表页:1:产品列表 2:落地页
  queryInfoActiveTab: 'policy'
};
const mutations = {
  SET_GROUP_SELECTED(state, data) {
    state.groupSelected = data;
  },
  SET_CONTROL_DATAS(state, data) {
    state.controlDatas = data;
  },
  SET_ITEMID(state, data) {
    state.itemid = data;
  },
  SET_ACTIVE_IDX(state, data) {
    state.activeIdx = data;
  },
  SET_GROUP_ITEM_ACTIVE_IDX(state, data) {
    state.groupItemActiveIdx = data;
  },
  SET_PAGE_SHOW(state, data) {
    state.pageModuleShow = data;
  },
  SET_QUERY_INFO_ACTIVE_TAB(state, data) {
    state.queryInfoActiveTab = data;
  }
};
const actions = {
  setGroupSelected({
    commit
  }, val) {
    commit('SET_GROUP_SELECTED', val);
  },
  setItemId({
    commit
  }, val) {
    commit('SET_ITEMID', val);
  },
  setControlDatas({
    commit
  }, val) {
    commit('SET_CONTROL_DATAS', val);
  },
  setActiveIdx({
    commit
  }, val) {
    commit('SET_ACTIVE_IDX', val);
  },
  setGroupItemActiveIdx({
    commit
  }, val) {
    commit('SET_GROUP_ITEM_ACTIVE_IDX', val);
  },
  setPageShow({
    commit
  }, val) {
    // 前端动态页面产品列表页
    commit('SET_PAGE_SHOW', val);
  },
  setQueryInfoActiveTab({
    commit
  }, val) {
    // 前端动态页面查询记录页
    commit('SET_QUERY_INFO_ACTIVE_TAB', val);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};